module.exports = __webpack_public_path__ + "static/media/background.1a610a9f.png";